import * as React from 'react';
import OrganizationCommunity from '../models/OrganizationCommunity';
import { OrganizationCommunityMembershipStatus } from '../models/OrganizationCommunityMembershipStatus';
import Loading from '../../shared/components/loading/Loading';
import * as moment from 'moment';
import CalendarIcon from '@material-ui/icons/PermContactCalendar';
import CheckIcon from '@material-ui/icons/Check';
import BlockedIcon from '@material-ui/icons/NotInterested';
import AddIcon from '@material-ui/icons/Add'
import BreadCrumb from '../../shared/components/BreadCrumb'

import { Grid, Card, CardContent, Avatar, Typography, List, ListItem, ListItemText, Divider, Tooltip } from '@material-ui/core';
import { withStyles, StyleRules } from '@material-ui/core/styles';
import { getMyMemberships } from "../../communities/api/communitiesApi";

interface IState {
  communities: OrganizationCommunity[],
  isLoading: boolean
}

const styles: StyleRules = {
  container: {
    justifyContent: 'flex-start',
    alignItems: 'center',
    display: 'flex',
    flexWrap: 'wrap',
    boxSizing: 'border-box',
    width: 'calc(100% + 24px)',
    margin: '-12px'
  },
  item1: {
    flex: '0 0 0',
    padding: '12px',
    boxSizing: 'border-box'
  },
  item2: {
    flex: '1 1 0',
    padding: '12px',
    boxSizing: 'border-box',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  }
};

class OrganizationCommunities extends React.Component<any, IState> {
  constructor(props: any) {
    super(props);
    this.state = {
      communities: [],
      isLoading: true
    }
    this.getCommunities = this.getCommunities.bind(this);
  }

  public componentDidMount() {
    this.getCommunities();
  }

  public async getCommunities() {
    this.setState({ isLoading: true })

    try {
      const myMemberships = await getMyMemberships();
      this.setState({
        ...this.state,
        communities: myMemberships,
        isLoading: false
      });
    } finally {
      this.setState({
        ...this.state,
        isLoading: false
      })
    }
    
  }

  public render() {
    return (
      <div>
        <Grid container justify="space-between" spacing={16} className="padding-bottom-24">
          <Grid item>
            <Typography color="textSecondary" gutterBottom>
              <BreadCrumb
                value='Organization'
                to='/organization/settings/'
              />
              communities
            </Typography>
          </Grid>
        </Grid>
        
        {this.state.isLoading &&
          <div>
            <Loading />
          </div>
        }
        { this.state.communities.length === 0 && 
          <Typography>
            Your entity has no community memberships.
          </Typography>
        }
        <Grid container={true} spacing={24} className='padding-bottom-24'>
          {this.state.communities.map((community: OrganizationCommunity, userIndex: number) => {
            return (
              <Grid item={true} key={userIndex}>
                <Card>
                  <CardContent>
                    <Grid container={true} wrap="nowrap" spacing={16} className='padding-bottom-8'>
                      <Grid item={true}>
                        <Avatar>{community.communityName.slice(0, 2)}</Avatar>
                      </Grid>
                      <Grid item={true} xs={true} zeroMinWidth={true}>
                        <Tooltip title={community.communityName} placement="bottom-start">
                          <Typography variant='subheading' noWrap={true}>
                            {community.communityName}
                          </Typography>
                        </Tooltip>
                      </Grid>
                    </Grid>
                    <List>
                      <li>
                        <Divider />
                      </li>
                      <ListItem>
                        {community.status === OrganizationCommunityMembershipStatus.Pending && <AddIcon />}
                        {community.status === OrganizationCommunityMembershipStatus.Active && <CheckIcon />}
                        {community.status === OrganizationCommunityMembershipStatus.Disabled && <BlockedIcon />}
                        {community.status === OrganizationCommunityMembershipStatus.Denied && <BlockedIcon />}
                        <ListItemText secondary={community.status} />
                      </ListItem>
                      <li>
                        <Divider />
                      </li>
                      <Tooltip title={'Membership requested on ' + moment(community.createdOn).format('YYYY-MM-DD, h:mm a')}>
                        <ListItem>
                          <CalendarIcon />
                          <ListItemText secondary={moment(community.createdOn).fromNow()} />
                        </ListItem>
                      </Tooltip>
                      <li>
                        <Divider />
                      </li>
                    </List>
                  </CardContent>
                </Card>
              </Grid>
            )
          })}
        </Grid>
      </div>
    )
  }
}

export default withStyles(styles)(OrganizationCommunities)



// WEBPACK FOOTER //
// ./src/modules/organization/pages/OrganizationCommunities.tsx